export const encodeToBase64 = (payload: string | number): string => {
  if (typeof payload === 'string') return btoa(payload);

  return encodeURIComponent(btoa(String(payload)));
};

export const decodeFromBase64 = (payload: string): string => {
  return atob(decodeURIComponent(payload));
};
